(function() {

    'use strict';

    angular.module('app').
    controller('NonManifestedShipmentsByLocation', NonManifestedShipmentsByLocation);

    NonManifestedShipmentsByLocation.$inject = ['$scope', 'Carrier', 'NonManifestedByLocationTableService'];

    function NonManifestedShipmentsByLocation($scope, Carrier, NonManifestedByLocationTableService) {

        var vm = this;

        init();

        function init() {
            vm.nonManifestedShipments = NonManifestedByLocationTableService;
        };
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/manifests/NonManifestedShipmentsByLocation.js